import {
  FURUI_FRUI_PLAN_MODAL_CHANGE,
} from './constants';

export function frui_planModalChange(visible,type) {
  return {
    type: FURUI_FRUI_PLAN_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FURUI_FRUI_PLAN_MODAL_CHANGE:
      return {
        ...state,
        frui_planModalType:action.data.type,
        frui_planModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/furui/redux/frui_planModalChange.js